const compareObjects = (obj1, obj2, path = '') => {
  const differences = [];
  
  if (!obj1 || !obj2) {
    if (obj1 !== obj2) {
      differences.push({
        path,
        oldValue: obj1,
        newValue: obj2
      });
    }
    return differences;
  }

  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

  for (const key of allKeys) {
    const currentPath = path ? `${path}.${key}` : key;
    const value1 = obj1[key];
    const value2 = obj2[key];

    // Gymnast comparison (debug logging removed)

    if (Array.isArray(value1) && Array.isArray(value2)) {
      // For arrays, compare lengths and elements
      if (value1.length !== value2.length) {
        differences.push({
          path: currentPath,
          oldValue: `${value1.length} items`,
          newValue: `${value2.length} items`
        });
      }
      // Compare array elements if they are objects
      value1.forEach((item, index) => {
        if (typeof item === 'object' && item !== null && value2[index]) {
          differences.push(...compareObjects(item, value2[index], `${currentPath}[${index}]`));
        }
      });
    } else if (typeof value1 === 'object' && typeof value2 === 'object' && value1 !== null && value2 !== null) {
      // Recursively compare nested objects
      differences.push(...compareObjects(value1, value2, currentPath));
    } else if (value1 !== value2) {
      // Compare primitive values
      differences.push({
        path: currentPath,
        oldValue: value1,
        newValue: value2
      });
    }
  }

  return differences;
};

export const compareCompetitions = (existing, importing) => {
  const sections = {
    competition: compareObjects(existing.competition, importing.competition, 'competition'),
    sessions: compareObjects(existing.sessions, importing.sessions, 'sessions'),
    gymnasts: compareObjects(existing.gymnasts, importing.gymnasts, 'gymnasts'),
    teams: compareObjects(existing.teams, importing.teams, 'teams'),
    judges: compareObjects(existing.judges, importing.judges, 'judges'),
    coaches: compareObjects(existing.coaches, importing.coaches, 'coaches'),
    levels: compareObjects(existing.levels, importing.levels, 'levels'),
    ageGroups: compareObjects(existing.ageGroups, importing.ageGroups, 'ageGroups'),
    events: compareObjects(existing.events, importing.events, 'events'),
    rotations: compareObjects(existing.rotations, importing.rotations, 'rotations')
  };

  return Object.entries(sections)
    .filter(([_, diffs]) => diffs.length > 0)
    .reduce((acc, [key, diffs]) => {
      acc[key] = diffs;
      return acc;
    }, {});
};
